import { ChevronLeft, Close } from "@monta/icons";
import React from "react";
import { getColor } from "../../scss";
import { useBreakLG } from "../../utils";
import BottomSheet, { useBottomSheet } from "../BottomSheet";
import styles from "./Breadcrumbs.module.scss";

export interface BreadcrumbProps {
  items: {
    label: string;
    link?: string;
  }[];
}

const Breadcrumb = (props: BreadcrumbProps) => {
  const { items: propItems } = props;
  const controller = useBottomSheet();
  const isLG = useBreakLG(true);

  const items: BreadcrumbProps["items"] = isLG
    ? propItems
    : propItems.length >= 3
      ? [
          propItems[0],
          {
            label: "...",
            link: "#",
          },
          propItems[propItems.length - 1],
        ]
      : propItems;

  return (
    <div className={styles["breadcrumb"]}>
      {items.map((item, index) => (
        <>
          {React.createElement(
            item.link ? "a" : "div",
            {
              href: item.link,
              onClick:
                isLG || items.length <= 3
                  ? undefined
                  : (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      controller.open();
                    },
            },
            item.label,
          )}
          {index !== items.length - 1 && (
            <ChevronLeft color={getColor("neutral-600")} />
          )}
        </>
      ))}
      {!isLG && (
        <BottomSheet
          {...controller}
          className={styles["breadcrumb-mobile"]}
          borderRadius="4"
        >
          <div className={styles["breadcrumb-mobile__header"]}>
            <Close onClick={controller.close} />
          </div>
          <div className={styles["breadcrumb-mobile__list"]}>
            {propItems.map((item, index) =>
              React.createElement(
                item.link ? "a" : "div",
                {
                  key: index,
                  href: item.link,
                },
                item.label,
              ),
            )}
          </div>
        </BottomSheet>
      )}
    </div>
  );
};

export default Breadcrumb;
